<script>

  export default {
    name: 'Labl',

    props: ['id', 'cssClass', 'skipWrapper', 'for'],
  }

</script>

<template>
  <label :class="$props.cssClass" :for="$props.for">
    <Msg :id="$props.id" :css-class="$props.cssClass" :skip-wrapper="$props.skipWrapper" />
  </label>
</template>